import { LimiteAdicionalTranchListagemComponent } from './limite-adicional-tranch-listagem/limite-adicional-tranch-listagem.component';
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { EscolhaModalidadeGuard } from "src/app/interceptors/escolha-modalidade.guard";
import { DominiosResolver } from "src/app/shared/resolvers/dominios.resolver";
import { CadastroLimiteAdicionalTranchComponent } from "./cadastro-limite/cadastro-limite-adicional-tranch/cadastro-limite-adicional-tranch.component";
import { LimiteAdicionalPesquisaComponent } from "./limite-adicional-pesquisa/limite-adicional-pesquisa.component";
import { LimiteAdicionalPorAfComponent } from './limite-adicional-por-af/limite-adicional-por-af.component';


const routes: Routes = [
    {
      path: 'limite-adicional',
      canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
      data: { canReuse: false },
      children: [
        {
      path: 'pesquisa',
      component: LimiteAdicionalPesquisaComponent,
        resolve: {
          dominios: DominiosResolver
        },

    },
   {
        path: 'edicao/:ideTranche',
        component: CadastroLimiteAdicionalTranchComponent,
        canActivate: [AuthenticationGuard],
        data: { canReuse: false },
    },
     {
        path: 'cadastro/:ideTranche',
        component: CadastroLimiteAdicionalTranchComponent,
        resolve: {
          dominios: DominiosResolver
        },
    },
    {
        path: 'cadastro/:ideTranche/:idLimite',
        component: CadastroLimiteAdicionalTranchComponent,
        resolve: {
          dominios: DominiosResolver
        },
    },
    {
        path: 'listar/:ideTranche',
        component: LimiteAdicionalTranchListagemComponent,
        resolve: {
          dominios: DominiosResolver
        },
    },
    {
      path: 'limite-af/cadastro/:ideTranche',
      component: LimiteAdicionalPorAfComponent,
      resolve: { dominios: DominiosResolver }
    },
    {
      path: 'limite-af/edicao/:ideTranche',
      component: LimiteAdicionalPorAfComponent,
      canActivate: [AuthenticationGuard],
      data: { canReuse: false }
    },
      ]
    },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class LimiteAdicionalRoutingModule { }
